import React, {useEffect} from 'react';
import styled from 'styled-components';

import {Loader} from 'shared/helpers';
import Preview3DErrorBoundary from 'components/customer/Preview3D/components/Preview3DErrorBoundary';
import {useRoomPlannerStandalonePreview} from './lib/useRoomPlannerStandalonePreview';

const RoomPlannerStandaloneWrapper = ({
    children,
    setInitialized,
}: React.PropsWithChildren & {setInitialized: (a: boolean) => void}) => {
    // Pull mountRef, readyToPrint, and isGeneratingReport from our custom hook
    const {mountRef, captureDone} = useRoomPlannerStandalonePreview();
    useEffect(() => {
        if (captureDone && setInitialized) {
            setInitialized(true);
        }
    }, [setInitialized, captureDone]);

    return (
        <Preview3DErrorBoundary bordered={false}>
            <RoomPlannerContainer style={{overflow: 'hidden'}}>
                {!captureDone ? (
                    <>
                        <Loader
                            loader={!captureDone}
                            smallPaddingTop={true}
                            loadingText={
                                <h5 className="mx-3">
                                    Please wait while we generate your report.
                                </h5>
                            }
                        />
                        <RoomPlanner ref={mountRef} />
                    </>
                ) : null}

                {children}
            </RoomPlannerContainer>
        </Preview3DErrorBoundary>
    );
};

const RoomPlannerContainer = styled.div`
    height: 100%;
`;

const RoomPlanner = styled.div`
    height: 100%;
`;

export default RoomPlannerStandaloneWrapper;
